module.exports = new __parcel__URL__("melon.9c97f1e1.svg").toString();